import React from "react";
import styled, { css } from "styled-components";

import { Text } from "src/library/components/Text";
import { TableRowStyled } from "src/core/products/components/ProductNutritionValuesTable/ProductNutritionValuesTableRow";

interface ProductNutritionValuesTableHeadersProps {
  headers: string[]
}

/**
 * Simply takes array of headers and renders th for table nutrition values table.
 */
const ProductNutritionValuesTableHeaders: React.ReactFCWithChildren<ProductNutritionValuesTableHeadersProps> = ({ headers }) => {
  return (
    <TableRowStyled>
      {headers.map((header, iteration) => (
        <TableHeader
          key={header.replace(/\s/g, "_")}
          borderLeft={iteration > 0}
        >
          <Text
            className="th-text"
            weight="bold"
          >
            {header}
          </Text>
        </TableHeader>
      ))}
    </TableRowStyled>
  );
};

const TableHeader = styled.th<{borderLeft?: boolean}>`
  ${({ theme, borderLeft = false }) => css`
    text-align: left;
    border-left: ${borderLeft ? "1px" : "0"} solid black;
    
    .th-text {
      margin-left: ${theme.spacing.margins.xs};
    }
  `}
`;

export default ProductNutritionValuesTableHeaders;
